<template>
  <div id="PayemntDefault">
    <Header></Header>
    <div class="header-area"></div>

    <div class="digest-container" :style="{ backgroundColor: getColor.primaryColor }">
      <div class="digest-box">
        <div class="franchisee-name digest-text">{{ GET_PAYMENT_INFORMATION.payload.store_name || 'TEST CAFE' }}</div>
        <div class="product-name digest-text">{{ GET_PAYMENT_INFORMATION.title }}</div>
        <div class="product-price">{{ GET_PAYMENT_INFORMATION.amount | CommaNumbersRemoveDecimals }} 원</div>
      </div>
    </div>
    <div class="fixed-area"></div>

    <div class="content">
      <router-view></router-view>
    </div>

    <Close v-if="GET_MODAL.close"></Close>
  </div>
</template>

<script>
import vuex from 'vuex'

import Header from '../components/Common/Header.vue'
import Close from '../components/modals/Close.vue'

import { CommaNumbersRemoveDecimals } from '../filters/numberFormat.js'

export default {
  components: {
    Header,
    Close
  },
  computed: {
    ...vuex.mapGetters({
      'getColor': 'style/getColor',
      'GET_MODAL': 'display/GET_MODAL',
      'GET_PAYMENT_INFORMATION': 'GET_PAYMENT_INFORMATION'
    })
  },
  filters: {
    CommaNumbersRemoveDecimals
  },
  mounted() {
    // console.log(window.history)
    // console.log(this.GET_PAYMENT_INFORMATION)
    // this.detectPaymentInformation();
  },
  methods: {
    ...vuex.mapActions({
      'DETECT_PAYMENT_INFORMATION': 'DETECT_PAYMENT_INFORMATION'
    }),
    async detectPaymentInformation() {
      let res = await this.DETECT_PAYMENT_INFORMATION();
      console.log('check', res)
    }
  }
}
</script>

<style lang="scss">
#PaymentDefault {
  position: relative;
}

.header-area {
  height: 44px;
}

.digest-container {
  z-index: 1000;
  position: fixed;
  width: 100%;

  .digest-box {
    @include basic-display;

    padding: 15px 30px 21px;

    color: #fff;

    .digest-text {
      height: 28px;

      font-size: 18px;
      font-weight: bold;

      line-height: 1.56;

      &:not(:first-child) {
        margin-top: 6px;
      }
    }
    .product-price {
      height:40px; 
      margin-top: 6px;

      font-size: 30px;
      font-weight: bold;

      line-height: 1.33;

      text-align: right;
    }
  }
}
.fixed-area {
  height: 144px;
}

.content {
  position: absolute;
  top: 188px;
  right: 0;
  bottom :0;
  left: 0;
}
</style>